import React from 'react-bootstrap';
import { Row, Col, Container} from "react-bootstrap";
import "../../styles/Gallerylist.css";

function Gallerylist() {
    return (
   
<Container className="Gallerylist"><br />
  <h5 className="title">Visual Stories</h5>

  {/* 1st Row - Photo Left, Text Right on Desktop */}
  <Row className="Row" style={{ minHeight: "180px", alignItems: "center" }}>
    <Col xs={12} xl={{ span: 6, order: 1 }}>
      <img className="d-block w-100 border" src="..\assets\About\Image1.jpeg" alt="img1" />
    </Col>
    <Col xs={12} xl={{ span: 6, order: 2 }}>
      <h4 className="text">Honored to be part of the ACT-Amrita School project and to host Dr. Gururaj Karajagi Sir at our premises.</h4>
    </Col>
  </Row><br />

  {/* 2nd Row - Photo Right, Text Left on Desktop */}
  <Row className="Row" style={{ minHeight: "180px", alignItems: "center" }}>
    <Col xs={12} xl={{ span: 6, order: 2 }}>
      <img className="d-block w-100 border" src="..\assets\About\image .jpg" alt="img2" />
    </Col>
    <Col xs={12} xl={{ span: 6, order: 1 }}>
      <h4 className="text">Proud to nurture local talent through successful internship programs.</h4>
    </Col>
  </Row><br />

  {/* 3rd Row - Photo Left, Text Right on Desktop */}
  <Row className="Row" style={{ minHeight: "180px", alignItems: "center" }}>
    <Col xs={12} xl={{ span: 6, order: 1 }}>
      <img className="d-block w-100 border" src="..\assets\About\Image2.jpeg" alt="img3" />
    </Col>
    <Col xs={12} xl={{ span: 6, order: 2 }}>
      <h4 className="text">Real impact — growing students, supporting local businesses.</h4>
    </Col>
  </Row><br />

  {/* 4th Row - Photo Right, Text Left on Desktop */}
  <Row className="Row" style={{ minHeight: "180px", alignItems: "center" }}>
    <Col xs={12} xl={{ span: 6, order: 2 }}>
      <img className="d-block w-100 border" src="..\assets\About\pic3.jpg" alt="img4" />
    </Col>
    <Col xs={12} xl={{ span: 6, order: 1 }}>
      <h4 className="text">Celebrating the Achievements of Our Graduates!</h4>
    </Col>
  </Row><br />

  {/* 5th Row - Photo Left, Text Right on Desktop */}
  <Row className="Row" style={{ minHeight: "180px", alignItems: "center" }}>
    <Col xs={12} xl={{ span: 6, order: 1 }}>
      <img className="d-block w-100 border" src="..\assets\About\img_7567_720.jpg" alt="img5" />
    </Col>
    <Col xs={12} xl={{ span: 6, order: 2 }}>
   <h4 className="text">Together in Every Celebration.</h4>
    </Col>
  </Row><br />
  </Container>
    
 );
};

export default Gallerylist;